<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Delete Text Message'"
        />
      </header>
      <div class="flex justify-center items-baseline mt-4">
        <p v-text="'Are you sure you want to delete this text message?'" />
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn-blue"
        @click="destroy"
        v-text="'Delete'"
      />
      <a
        class="mx-6"
        href="#"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'DeleteSMSModal',
  data() {
    return {
      error: '',
    }
  },
  computed: {
    sms() {
      return this.$store.state.communication.deleteSMSModal.sms
    },
    uuid() {
      return this.sms.uuid
    },
    show() {
      return this.$store.state.communication.deleteSMSModal.open
    },
  },
  methods: {
    destroy() {
      this.$api.active().delete(`communications/sms/${this.uuid}`)
        .then(() => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Text Message Deleted!',
          })

          this.close()

          this.$emit('destroyed')
        }).catch((error) => {
          this.error = error.response.data.message

          this.$store.commit('baseAddNotification', {
            type: 'error',
            title: 'Error',
            text: error.response.data.message,
          })
        })
    },
    close() {
      this.error = ''

      this.$store.commit('communicationCloseDeleteSMSModal')
    },
  },
}
</script>
